// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__W2qeD","ant-page-header-heading-title":"styles_ant-page-header-heading-title__QxFWC","table":"styles_table__HH8Ei"};